/* tbs-analytics (2026-07) - page-level GA4 for custom events.
   Bootstraps gtag for the store's GA4 property (G-KDD4LNYSV7 - the same one the
   Google & YouTube channel pixel reports to) with send_page_view:false, so this
   sends ONLY custom events; standard commerce events stay with the channel
   pixel (no double-counting). Side effect: the theme's existing
   lp_contact_form / lp_quote_form gtag calls become functional (gtag was
   previously undefined on the page).
   Emits `collection_filter` events by diffing URL params whenever
   tbs-ajax-filters.js dispatches `tbs:collection:updated`. Params:
   filter_action (add|remove|clear|sort|page), filter_name, filter_value,
   collection, results_count. Register those as custom dimensions in GA4 admin
   for full reporting. Per-page changes carry no URL change and are not tracked.
   Bulk changes of one filter (3+ values at once, e.g. a tbs-range-filters
   slider apply) coalesce into a single event with value "first..last (N values)". */
(function () {
  'use strict';
  if (window.__tbsAnalytics) return;
  window.__tbsAnalytics = true;

  var MID = 'G-KDD4LNYSV7';
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () { window.dataLayer.push(arguments); };
  }
  window.gtag('js', new Date());
  window.gtag('config', MID, { send_page_view: false });
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MID;
  document.head.appendChild(s);

  function shortName(key) {
    return key.replace(/^filter\.(p\.m\.custom\.|p\.m\.|v\.|p\.)/, '');
  }

  function stateOf(search) {
    var out = { pairs: [], price: {}, sort: null, page: null };
    new URLSearchParams(search).forEach(function (value, key) {
      if (key === 'filter.v.price.gte') out.price.gte = value;
      else if (key === 'filter.v.price.lte') out.price.lte = value;
      else if (key.indexOf('filter.') === 0) out.pairs.push(JSON.stringify([shortName(key), value]));
      else if (key === 'sort_by') out.sort = value;
      else if (key === 'page') out.page = value;
    });
    return out;
  }

  function resultsCount() {
    var el = document.querySelector('.collection__showing-count');
    var m = el && el.textContent.match(/of\s+([\d,]+)/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : undefined;
  }

  function send(action, name, value) {
    var m = location.pathname.match(/\/collections\/([^\/]+)/);
    window.gtag('event', 'collection_filter', {
      filter_action: action,
      filter_name: name,
      filter_value: String(value).slice(0, 90),
      collection: m ? m[1] : 'search',
      results_count: resultsCount()
    });
  }

  var prev = stateOf(location.search);

  document.addEventListener('tbs:collection:updated', function () {
    var next = stateOf(location.search);
    var i, parts;

    var added = next.pairs.filter(function (p) { return prev.pairs.indexOf(p) < 0; });
    var removed = prev.pairs.filter(function (p) { return next.pairs.indexOf(p) < 0; });
    var prevHadPrice = prev.price.gte !== undefined || prev.price.lte !== undefined;
    var nextHasPrice = next.price.gte !== undefined || next.price.lte !== undefined;

    if (!next.pairs.length && !nextHasPrice && (removed.length + (prevHadPrice ? 1 : 0)) > 1) {
      send('clear', 'all', '');
    } else {
      var addBy = {}, remBy = {};
      for (i = 0; i < added.length; i++) {
        parts = JSON.parse(added[i]);
        (addBy[parts[0]] = addBy[parts[0]] || []).push(parts[1]);
      }
      for (i = 0; i < removed.length; i++) {
        parts = JSON.parse(removed[i]);
        (remBy[parts[0]] = remBy[parts[0]] || []).push(parts[1]);
      }
      Object.keys(addBy).forEach(function (name) {
        var vs = addBy[name];
        if (vs.length <= 2) vs.forEach(function (v) { send('add', name, v); });
        else send('add', name, vs[0] + '..' + vs[vs.length - 1] + ' (' + vs.length + ' values)');
      });
      Object.keys(remBy).forEach(function (name) {
        var vs = remBy[name];
        if (vs.length <= 2) vs.forEach(function (v) { send('remove', name, v); });
        else send('remove', name, vs[0] + '..' + vs[vs.length - 1] + ' (' + vs.length + ' values)');
      });
      if (nextHasPrice && (next.price.gte !== prev.price.gte || next.price.lte !== prev.price.lte)) {
        send('add', 'price', (next.price.gte || 'min') + '-' + (next.price.lte || 'max'));
      } else if (prevHadPrice && !nextHasPrice) {
        send('remove', 'price', (prev.price.gte || 'min') + '-' + (prev.price.lte || 'max'));
      }
    }

    if (next.sort !== prev.sort) send('sort', 'sort_by', next.sort || 'default');
    if (next.page !== prev.page) send('page', 'page', next.page || '1');

    prev = next;
  });
})();